if (!customElements.get('wls-s-buybox-product-gallery')) {
  class WLS_S_BuyboxProductGallery extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        active: 'active',
        hidden: 'hidden',
        disabled: 'disabled',
        mainSlider: 'js-buybox-gallery-main-slider',
        thumbSlider: 'js-buybox-gallery-thumb-slider',
        mainSlide: 'js-buybox-gallery-main-slide',
        thumbSlide: 'js-buybox-gallery-thumb-slide',
        thumbContainer: 'js-buybox-gallery-thumb-container',
      };

      this.selectors = {
        mainSlider: this.querySelector(`.${this.classes.mainSlider}`),
        thumbSlider: this.querySelector(`.${this.classes.thumbSlider}`),
        mainSlides: this.querySelectorAll(`.${this.classes.mainSlide}`),
        thumbSlides: this.querySelectorAll(`.${this.classes.thumbSlide}`),
        thumbContainer: this.querySelector(`.${this.classes.thumbContainer}`),
      };

      this.mainSwiper = null;
      this.thumbSwiper = null;
      this.minThumbsForSlider = 2; // Minimum number of thumbnails to show slider
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.initThumbSlider();
      this.initMainSlider();
    }

    initThumbSlider() {
      if (!this.selectors.thumbContainer || !this.selectors.thumbSlider) return;

      // Check if we have enough thumbnails to show slider
      if (this.selectors.thumbSlides.length < this.minThumbsForSlider) {
        this.hideThumbSlider();
        return;
      }

      const slidesLength = this.selectors.thumbSlides.length;

      this.thumbSwiper = new Swiper(this.selectors.thumbSlider, {
        loop: slidesLength > 6,
        spaceBetween: 4,
        slidesPerView: 6,
        watchSlidesProgress: true,
        breakpoints: {
          768: {
            spaceBetween: 16,
          },
        },
      });
    }

    initMainSlider() {
      if (!this.selectors.mainSlider) return;

      this.mainSwiper = new Swiper(this.selectors.mainSlider, {
        loop: true,
        spaceBetween: 10,
        thumbs: {
          swiper: this.thumbSwiper,
        },
        keyboard: {
          enabled: true,
        },
        grabCursor: true,
      });
    }

    hideThumbSlider() {
      if (this.selectors.thumbContainer) {
        this.selectors.thumbContainer.classList.add(this.classes.hidden);
      }
    }

    disconnectedCallback() {
      if (this.mainSwiper) {
        this.mainSwiper.destroy(true, true);
      }
      if (this.thumbSwiper) {
        this.thumbSwiper.destroy(true, true);
      }
    }
  }
  customElements.define('wls-s-buybox-product-gallery', WLS_S_BuyboxProductGallery);
}
